import { monthEndAlertConstants } from '../../actions/constant';

const {
  GET_MONTH_END_ALERTS_COUNT_REQUEST,
  GET_MONTH_END_ALERTS_COUNT_SUCCESS,
  GET_MONTH_END_ALERTS_COUNT_FAILURE,
  GET_CURRENT_MONTH_ALERT_COUNT_SUCCESS,
} = monthEndAlertConstants;

const intitialstate: object = {
  response: null,
  isError: false,
  loading: false,
  thisMonth: null,
};

export const getMonthEndAlertCountReducer = (state = intitialstate, action: any) => {
  switch (action.type) {
    case GET_MONTH_END_ALERTS_COUNT_SUCCESS: {
      return {
        ...state,
        isError: false,
        response: action.payload?.data,
        loading: false,
      };
    }
    case GET_MONTH_END_ALERTS_COUNT_FAILURE:
      return {
        ...state,
        isError: true,
        response: null,
        loading: false,
      };
    case GET_MONTH_END_ALERTS_COUNT_REQUEST:
      return {
        ...state,
        loading: true,
        isError: false,
      };

    case GET_CURRENT_MONTH_ALERT_COUNT_SUCCESS:
      return {
        ...state,
        thismonth: action.payload?.data,
      };
    default:
      return state;
  }
};
